<svg [class]="hostClasses" viewBox="0 0 320 140" preserveAspectRatio="xMidYMax meet"
  [attr.role]="ariaLabel ? 'img' : null" [attr.aria-label]="ariaLabel || null"
  [attr.aria-hidden]="ariaLabel ? null : true">

    <!-- ── Lo constante de la familia ────────────────────────────────────────
         El piso y el equipo. Se escriben UNA vez y se instancian: es la
         diferencia entre una familia y siete dibujos sueltos. El piso es la
         misma línea que ancla a `dxc-state-icon` (`M6 76h84` sobre la rejilla
         de 96), a esta escala — así las dos familias se leen como una.

         El contenedor es de 20 pies y no de 40 a propósito. No es un detalle
         de estilo: con la caja larga el remolque ocupa cuatro quintos del
         lienzo y las escenas que necesitan sitio al lado —la carga en el
         suelo, la pluma delante de la cabina, la bifurcación— no lo tienen.
         Con la corta, el equipo sigue siendo el mismo en las siete y cada una
         puede desplazarlo sin salirse. -->

    <ng-template #piso>
        <path class="sf" d="M16 118h288"/>
    </ng-template>

    <ng-template #tractor>
        <g>
            <path class="ln" d="M38 96h142v7H38z"/>
            <path class="ln" d="M188 103V62a5 5 0 0 1 5-5h32l19 22v24z"/>
            <path class="sf" d="M198 65h21v13h-21z"/>
            <path class="sf" d="M240 91h5"/>
            <circle class="ln" cx="204" cy="107" r="9.5"/><circle class="sf" cx="204" cy="107" r="3"/>
            <circle class="ln" cx="232" cy="107" r="9.5"/><circle class="sf" cx="232" cy="107" r="3"/>
        </g>
    </ng-template>

    <ng-template #bogie>
        <g>
            <circle class="ln" cx="66" cy="107" r="9.5"/><circle class="sf" cx="66" cy="107" r="3"/>
            <circle class="ln" cx="92" cy="107" r="9.5"/><circle class="sf" cx="92" cy="107" r="3"/>
        </g>
    </ng-template>

    <!-- Corrugado, panel de puerta y manija: es el mismo objeto que dibuja el
         icono `container` a 24, con el presupuesto de detalle que da el
         tamaño. La manija va en el trazo oscuro y no en el suave porque a esta
         escala es lo único que distingue la trasera de una corruga más. -->
    <ng-template #contenedor>
        <g>
            <path class="ln" d="M42 46h102v50H42z"/>
            <path class="sf" d="M60 52v38M78 52v38M96 52v38M114 52v38M132 52v38"/>
            <path class="sf" d="M51 48v46"/>
            <path class="ln" d="M46 68h9"/>
        </g>
    </ng-template>

    <!-- Los amarres sobresalen por arriba y bajan hasta el larguero, con su
         hebilla: dentro de la caja se leían como dos corrugas más de color. -->
    <ng-template #amarres>
        <g>
            <path class="ac" d="M66 40v62M120 40v62"/>
            <path class="ac sc-buckle" d="M61 88h10M115 88h10"/>
        </g>
    </ng-template>

    @switch (name) {

        <!-- ── entrega ───────────────────────────────────────────────────────
             Éxito. En reposo: la carga va montada, los dos amarres cerrados y
             el sello estampado. La animación cuenta cómo llegó —el contenedor
             baja, los amarres se cierran, el sello se estampa y el equipo
             arranca— pero si no llega a correr nunca, el dibujo dice lo mismo. -->
        @case ('entrega') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <g class="sc-speed"><path class="sf" d="M12 58h22M4 80h28"/></g>
                <ng-container *ngTemplateOutlet="bogie"></ng-container>
                <ng-container *ngTemplateOutlet="tractor"></ng-container>
                <g class="sc-drop"><ng-container *ngTemplateOutlet="contenedor"></ng-container></g>
                <ng-container *ngTemplateOutlet="amarres"></ng-container>
                <g class="sc-stamp">
                    <circle class="acf" cx="272" cy="34" r="17"/>
                    <path class="sc-mark" d="M264 34l6 6 11-12"/>
                </g>
            </ng-container>
        }

        <!-- ── carga-caida ───────────────────────────────────────────────────
             Error. En reposo: el contenedor está EN EL SUELO, volcado y
             separado del equipo; el larguero se ve VACÍO y el amarre reventado
             cuelga de él. Esas tres cosas a la vez son lo que impide leerlo
             como «ladeado pero todavía cargado», que es en lo que se quedaba
             la primera versión.

             El equipo se corre a la derecha para dejar sitio a la carga en el
             suelo. Es el mismo equipo, movido — no un segundo dibujo. -->
        @case ('carga-caida') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <g transform="translate(56,0)">
                    <ng-container *ngTemplateOutlet="bogie"></ng-container>
                    <ng-container *ngTemplateOutlet="tractor"></ng-container>
                    <!-- El amarre reventado: un cabo corto colgando del larguero
                         vacío. Es la señal de FORMA que sobrevive a la escala de
                         grises (§9) — el rojo por sí solo no distingue esta
                         escena de la de entrega. -->
                    <path class="ac sc-whip" d="M120 92v-24"/>
                </g>
                <g class="sc-fall">
                    <ng-container *ngTemplateOutlet="contenedor"></ng-container>
                    <!-- El otro cabo del mismo amarre, el que se fue con la
                         carga. Los dos a la vez son lo que se lee como «se
                         reventó»; uno solo se lee como una raya. -->
                    <path class="ac" d="M66 40v22"/>
                </g>
                <g class="sc-dust">
                    <path class="sf" d="M18 112c6-7 14-9 20-6"/>
                    <path class="sf" d="M112 110c-5-6-12-8-18-5"/>
                </g>
            </ng-container>
        }

        <!-- ── retencion ─────────────────────────────────────────────────────
             Aviso: requiere acción del usuario (§5). En reposo la pluma está
             BAJA y la lámpara encendida — el equipo no pasa. El equipo se corre
             a la izquierda para que la pluma quede DELANTE de la cabina: en la
             primera versión la atravesaba, y una pluma que cruza el camión no
             lo detiene, lo parte. -->
        @case ('retencion') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <g transform="translate(-26,0)">
                    <ng-container *ngTemplateOutlet="bogie"></ng-container>
                    <ng-container *ngTemplateOutlet="tractor"></ng-container>
                    <ng-container *ngTemplateOutlet="contenedor"></ng-container>
                    <ng-container *ngTemplateOutlet="amarres"></ng-container>
                </g>
                <path class="sf" d="M292 118V50M282 118h20"/>
                <g class="sc-arm">
                    <path class="acf" d="M290 72h-58a4 4 0 0 0 0 8h58z"/>
                    <path class="sc-mark" d="M244 72v8M262 72v8M280 72v8"/>
                </g>
                <circle class="acf sc-lamp" cx="292" cy="42" r="6"/>
            </ng-container>
        }

        <!-- ── decision ──────────────────────────────────────────────────────
             Pregunta. El equipo llega al portón del patio, el conductor asoma
             y la duda es SUYA: la escena pone a alguien decidiendo, no una
             señal abstracta.

             La primera versión dibujaba dos ramales de ruta divergiendo, y era
             un error de encuadre: un diálogo de confirmación casi nunca
             pregunta «¿por cuál de dos caminos?», pregunta «¿lo hago?». Un
             conductor parado en la puerta esperando el visto bueno es esa
             pregunta, y además es una escena que cualquiera del negocio ha
             visto.

             Se distingue de `retencion` por el objeto y por quien está: allí es
             una pluma con su lámpara y no hay nadie —al equipo lo detienen—;
             aquí es un portón y hay un conductor asomado —el equipo pregunta—.

             Es la única escena que va en bucle junto con `en-ruta`, y no por
             gusto: una confirmación está esperando una respuesta, así que su
             condición sigue siendo cierta mientras el diálogo esté abierto.
             Las otras cinco cuentan algo que ya terminó. Por eso la llegada se
             reproduce una vez y solo la duda repite. -->
        @case ('decision') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <!-- El portón del patio: dos guías, el tambor arriba y la
                     cortina a MEDIA subida, con su barra inferior en el trazo
                     oscuro. La primera versión era un marco con dos líneas
                     dentro y se leía como una hoja de papel —peor aún, como la
                     carta porte de `timbrado`—: lo que la convierte en portón
                     es que las lamas se acaban a media altura y debajo se ve el
                     hueco por el que se entra. -->
                <path class="sf" d="M230 118V40M296 118V40"/>
                <path class="ln" d="M226 40h74"/>
                <path class="sf" d="M236 50h54M236 58h54M236 66h54M236 74h54"/>
                <path class="ln" d="M234 82h58"/>
                <g class="sc-arrive">
                    <g transform="translate(-34,0)">
                        <ng-container *ngTemplateOutlet="bogie"></ng-container>
                        <ng-container *ngTemplateOutlet="tractor"></ng-container>
                        <ng-container *ngTemplateOutlet="contenedor"></ng-container>
                        <ng-container *ngTemplateOutlet="amarres"></ng-container>
                        <!-- El conductor, dentro del parabrisas. Va en el
                             relleno de acento y no en el trazo del equipo
                             porque a esta escala una silueta de contorno de
                             8 px se pierde entre las líneas de la cabina. -->
                        <circle class="acf" cx="206" cy="70" r="4"/>
                        <path class="ac" d="M200 78.5c1.2-3.2 3.4-4.9 6-4.9s4.8 1.7 6 4.9" stroke-width="2.2"/>
                    </g>
                    <g class="sc-ask">
                        <circle class="acf" cx="220" cy="28" r="17"/>
                        <path class="sc-mark" d="M215 24.2c0-3 2.3-5.2 5-5.2s5 2.1 5 4.9c0 3.4-5 3.9-5 7.6"/>
                        <path class="sc-mark" d="M220 35.6v.1"/>
                    </g>
                </g>
            </ng-container>
        }

        <!-- ── en-ruta ───────────────────────────────────────────────────────
             En curso, sin acción pendiente (§5). Bucle por el mismo motivo que
             `decision`: la condición sigue siendo cierta mientras se mira. -->
        @case ('en-ruta') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <g class="sc-speed sc-speed--loop"><path class="sf" d="M12 58h22M4 80h28"/></g>
                <ng-container *ngTemplateOutlet="bogie"></ng-container>
                <ng-container *ngTemplateOutlet="tractor"></ng-container>
                <ng-container *ngTemplateOutlet="contenedor"></ng-container>
                <ng-container *ngTemplateOutlet="amarres"></ng-container>
                <g class="sc-pin">
                    <path class="ac" d="M280 68c-8 0-14 6-14 14 0 10 14 24 14 24s14-14 14-24c0-8-6-14-14-14z"/>
                    <circle class="acf" cx="280" cy="81" r="5"/>
                </g>
            </ng-container>
        }

        <!-- ── timbrado ──────────────────────────────────────────────────────
             Éxito fiscal. El objeto ya no es la carga sino la carta porte: el
             sello prendido en la esquina y el folio escrito. Comparte el piso
             con el resto de la familia —la hoja se apoya en él— para que las
             dos mitades del conjunto se lean como una. -->
        @case ('timbrado') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <path class="ln" d="M86 22h124a4 4 0 0 1 4 4v88a4 4 0 0 1-4 4H86a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4z"/>
                <path class="sf" d="M98 42h58M98 58h84M98 74h42"/>
                <path class="ac sc-folio" d="M98 98h58"/>
                <g class="sc-press">
                    <circle class="acf" cx="196" cy="92" r="20"/>
                    <path class="sc-mark" d="M187 92l6 7 13-14"/>
                </g>
            </ng-container>
        }

        <!-- ── sello-rechazado ───────────────────────────────────────────────
             Error fiscal, y la escena tiene que distinguirse de `timbrado` de
             un vistazo — no por el color, que en escala de grises no está.
             Tres señales de forma, todas en reposo:

               · el sello está FUERA de la hoja, no prendido en su esquina;
               · queda el HUECO punteado donde debía haber caído;
               · el renglón del folio sigue vacío, punteado.

             El PAC devuelve un código, y el diálogo lo enseña: el dibujo dice
             qué pasó, el `code` dice cuál. -->
        @case ('sello-rechazado') {
            <ng-container>
                <ng-container *ngTemplateOutlet="piso"></ng-container>
                <path class="ln" d="M86 22h124a4 4 0 0 1 4 4v88a4 4 0 0 1-4 4H86a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4z"/>
                <path class="sf" d="M98 42h58M98 58h84M98 74h42"/>
                <path class="sf" d="M98 98h58" stroke-dasharray="5 6"/>
                <circle class="sf" cx="196" cy="92" r="20" stroke-dasharray="5 6"/>
                <g class="sc-reject">
                    <circle class="acf" cx="262" cy="46" r="20"/>
                    <path class="sc-mark" d="M255 39l14 14M269 39l-14 14"/>
                </g>
            </ng-container>
        }
    }
</svg>
